import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as ClockIcon } from '@blink/assets/src/icons/clockInCircle.svg';

import { useVaultActivationInProgressStyle } from './VaultActivationInProgressModal.style';
import { useModal } from '../../ModalWrapperHooks';
import { OperationStatusType } from '../../../../features/Modals/ui/OperationStatusModal';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { useGetVaultMarginAccounts } from '@/shared/hooks/useGetVaultMarginAccounts';
import { ACCOUNT_STATUS } from '@/shared/api/vault';
import { getVaultPools } from '@/shared/store/vaults/actions';
import { getAgreementsAction } from '@/shared/store/agreements/actions';
import { ROLE } from '@/shared/api/borrow';

const REQUEST_INTERVAL = 10000;

export const VaultActivationInProgressModal = () => {
    const classes = useVaultActivationInProgressStyle();

    const { modalProps, onClose } = useModal();

    const dispatch = useDispatch();

    const { address } = modalProps;

    const { data: marginAccounts, fetchMarginAccounts } = useGetVaultMarginAccounts();

    const currentAccount = useMemo(
        () => marginAccounts?.find((account) => account.agreementAddress === address),
        [marginAccounts, address],
    );

    const refresh = async () => {
        dispatch(
            getAgreementsAction({
                role: ROLE.LENDER,
                withoutCache: true,
            }),
        );

        dispatch(
            getVaultPools({
                vaultAddress: address,
                marginAccountAddress: currentAccount?.address as string,
                withoutCache: true,
            }),
        );
    };

    const handleClose = async () => {
        onClose?.();

        await refresh();
    };

    useEffect(() => {
        const interval = setInterval(() => {
            fetchMarginAccounts();
        }, REQUEST_INTERVAL);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (currentAccount && currentAccount.status === ACCOUNT_STATUS.OPENED) {
            dispatch(
                showModalAction({
                    modalName: ModalName.OPERATION_STATUS_MODAL,
                    modalProps: {
                        type: OperationStatusType.Success,
                        title: 'Vault Activated',
                        description: 'Your vault is now active and ready for management.',
                        closable: true,
                    },
                    onClose: handleClose,
                }),
            );
        }
    }, [currentAccount]);

    return (
        <>
            <div className={classes.vaultActivationInProgressModalWrapper}>
                <ClockIcon />
            </div>
            <div className={classes.wrapper}>
                <h3 className={classes.title}>Vault Activation in Progress</h3>
                <p className={classes.subtitle}>
                    Your vault activation is in progress and should complete in about 1.5 minutes.
                    You may close this page; it won't affect the process. Sources
                </p>
            </div>
        </>
    );
};
